import { uuid as zodUuid, type ZodMiniType } from 'zod/mini';

import { EntityNotFoundError } from '../../components/ErrorPage/Errors';

import type { NID, SID } from '@navina/api-types';

const NAVINA_PATIENT_ID_SCHEMA: ZodMiniType<NID> = zodUuid();
const NAVINA_APPOINTMENT_ID_SCHEMA: ZodMiniType<SID> = zodUuid();

export function getNavinaPatientIdOrThrow(maybeNavinaPatientId: string | undefined): NID {
	if (!maybeNavinaPatientId) {
		throw new EntityNotFoundError('Navina Patient ID URL parameter is missing');
	}

	const parsedNavinaPatientId = NAVINA_PATIENT_ID_SCHEMA.safeParse(maybeNavinaPatientId);

	if (!parsedNavinaPatientId.success) {
		throw new EntityNotFoundError('Navina Patient ID URL parameter is not a valid UUID');
	}

	return parsedNavinaPatientId.data;
}

export function getNavinaAppointmentIdOrThrow(maybeNavinaAppointmentId: string | undefined): SID {
	if (!maybeNavinaAppointmentId) {
		throw new EntityNotFoundError('Navina Appointment ID URL parameter is missing');
	}

	const parsedNavinaAppointmentId = NAVINA_APPOINTMENT_ID_SCHEMA.safeParse(maybeNavinaAppointmentId);

	if (!parsedNavinaAppointmentId.success) {
		throw new EntityNotFoundError('Navina Appointment ID URL parameter is not a valid UUID');
	}

	return parsedNavinaAppointmentId.data;
}

export function getOptionalNavinaAppointmentIdOrThrow(maybeNavinaAppointmentId: string | undefined): SID | undefined {
	if (maybeNavinaAppointmentId === undefined) {
		return undefined;
	}

	return getNavinaAppointmentIdOrThrow(maybeNavinaAppointmentId);
}

export function getSkipValidationSearchParam(searchParams: URLSearchParams): 'true' | 'false' | undefined {
	const skipValidation = searchParams.get('skipValidation');

	return skipValidation === 'true' || skipValidation === 'false' ? skipValidation : undefined;
}
